import { render, staticRenderFns } from "./voice-integrity-registration-dialog.vue?vue&type=template&id=6d04f478"
import script from "./voice-integrity-registration-dialog.vue?vue&type=script&lang=js"
export * from "./voice-integrity-registration-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports